import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import TalentList from '../../components/admin/talent/TalentList';
import TalentForm from '../../components/admin/talent/TalentForm';
import './AdminTalent.css';

const AdminTalent = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingTalent, setEditingTalent] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAdd = () => {
    setEditingTalent(null);
    setShowForm(true);
  };

  const handleEdit = (talent) => {
    setEditingTalent(talent);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingTalent(null);
  };

  const handleSave = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="admin-talent-page">
      <div className="admin-page-header">
        <h1 className="admin-page-title">Talent</h1>
        <button onClick={handleAdd} className="btn btn-primary">
          <Plus size={20} />
          Add Talent
        </button>
      </div>

      <TalentList 
        key={refreshKey}
        onEdit={handleEdit} 
        onAdd={handleAdd}
      />

      {showForm && (
        <TalentForm
          talent={editingTalent}
          onClose={handleClose}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default AdminTalent;